<template>
    <v-card flat color="transparent">
        <v-card-text class="pt-0">
            <slot name="cardContent"></slot>
        </v-card-text>
    </v-card>

</template>
<script>
export default {
    props: [],
    
   
}
</script>

<style lang="scss">
    
</style>